import 'core-js/stable';
import 'regenerator-runtime/runtime';
import VuePlyr from 'vue-plyr';
import * as Vue from 'vue';
import { initMenuMain } from './menu/menu-main';
import { initAnchorMenu } from './page/anchor-menu';
import { initShieldedSite } from './footer/shielded-site';
import { initAboutPageLanguage } from './page/about-page-language';
import { initTSMButton } from './page/tsm-button';
import { initCopyUrl } from './page/copy-url';
import { initResourceSearch } from './search/resource-search';

import VideoBlock from './components/VideoBlock.vue';
import AudioBlock from './components/AudioBlock.vue';
import Navigator from './components/Navigator.vue';
import Accordion from './components/Accordion.vue';



const app = Vue.createApp({
  components: {
    VideoBlock,
    Navigator,
    AudioBlock,
    Accordion,
  },
  mounted() {
    initMenuMain();
    initShieldedSite();
    initAboutPageLanguage();
    initAnchorMenu();
    initTSMButton();
    initCopyUrl();
    initResourceSearch();
  },
});

app.use(VuePlyr, {
  plyr: {
    settings: [],
    iconUrl:
      '/themes/custom/education_base/dist/images/vue-plyr-icons/vue-plyr-sprite.svg',
    // Override Plyr defaults.
    // https://github.com/sampotts/plyr#getters-and-setters
    controls: [
      'play-large', // The large play button in the center
      'rewind', // Rewind by the seek time (default 10 seconds)
      'play', // Play/pause playback
      'fast-forward', // Fast forward by the seek time (default 10 seconds)
      'progress', // The progress bar and scrubber for playback and buffering
      'current-time', // The current time of playback
      'duration', // The full duration of the media
      'mute', // Toggle mute
      'volume', // Volume control
      'captions', // Toggle captions
      'fullscreen', // Toggle fullscreen
    ],
  },
});

app.mount('#app');
